import React, { useEffect, useState } from 'react';
import { DataService } from './../services/DataService';

const Dashboard = (props) => {
    // Extracting necessary data from jsondata
    const [dashboardData, setDashboardData] = useState([]);

    useEffect(() => {

        var _dashboardData = props != null ? props.dashboardData : {};
        setDashboardData(_dashboardData);
        console.log(_dashboardData);
        // var jsondata = new DataService().getTestData();
        // const originPlate = jsondata.OriginLocation;
        // const destinationPlate = jsondata.DestinationLocation;
    }, [props])

    return (<>
        <section className="ftco-section ftco-section2">
            <div className="container1">
                {/* <div className="row justify-content-center pb-4">
                    <div className="col-md-12 heading-section text-center ">
                        <span className="subheading">Best for you</span>
                        <h2 className="mb-4">Flight Information</h2>
                    </div>
                </div> */}
                <div className="row">
                    <div className="col-md-3 ">
                        <div className="project-wrap">
                            <a href="#" className="img" style={{ backgroundImage: "url(assets/images/bg_3.jpg)" }}>
                                <span className="price">Best travel time</span>
                            </a>
                            <div className="text p-4">
                                <span className="days">{dashboardData.bestTime ? `${dashboardData.bestTime.TravelTimeString}` : 0}</span>
                                {/* <h3><a href="#">Banaue Rice Terraces</a></h3>
                                <p className="location"><span className="fa fa-map-marker"></span> Banaue, Ifugao, Philippines</p>
                                <ul>
                                    <li><span className="flaticon-shower"></span>2</li>
                                    <li><span className="flaticon-king-size"></span>3</li>
                                    <li><span className="flaticon-mountains"></span>Near Mountain</li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className="project-wrap">
                            <a href="#" className="img" style={{ backgroundImage: "url(assets/images/bg_3.jpg)" }}>
                                <span className="price">Best price</span>
                            </a>
                            <div className="text p-4">
                                <span className="days">{dashboardData.bestPrice ? `${dashboardData.bestPrice.Amount} ${dashboardData.bestPrice.CurrencyCode}` : 0}</span>
                                {/* <h3><a href="#">Banaue Rice Terraces</a></h3>
                                <p className="location"><span className="fa fa-map-marker"></span> Banaue, Ifugao, Philippines</p>
                                <ul>
                                    <li><span className="flaticon-shower"></span>2</li>
                                    <li><span className="flaticon-king-size"></span>3</li>
                                    <li><span className="flaticon-sun-umbrella"></span>Near Beach</li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className="project-wrap">
                            <a href="#" className="img" style={{ backgroundImage: "url(assets/images/bg_3.jpg)" }}>
                                <span className="price">Best route</span>
                            </a>
                            <div className="text p-4">
                                <span className="days">{dashboardData.bestTime ? `${dashboardData.bestTime.DepartureAirport} - ${dashboardData.bestTime.ArrivalAirport} (Flight No: ${dashboardData.bestTime.FlightNumber})` : 0}</span>
                                {/* <h3><a href="#">Banaue Rice Terraces</a></h3>
                                <p className="location"><span className="fa fa-map-marker"></span> Banaue, Ifugao, Philippines</p>
                                <ul>
                                    <li><span className="flaticon-shower"></span>2</li>
                                    <li><span className="flaticon-king-size"></span>3</li>
                                    <li><span className="flaticon-sun-umbrella"></span>Near Beach</li>
                                </ul> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-3 ">
                        <div className="project-wrap">
                            <a href="#" className="img" style={{ backgroundImage: "url(assets/images/bg_3.jpg)" }}>
                                <span className="price">Best rated</span>
                            </a>
                            <div className="text p-4">
                                <span className="days">{dashboardData.bestTime ? `${dashboardData.bestTime.DepartureAirport} - ${dashboardData.bestTime.ArrivalAirport} (Flight No: ${dashboardData.bestTime.FlightNumber})` : 0}</span>
                                {/* <h3><a href="#">Banaue Rice Terraces</a></h3>
                                <p className="location"><span className="fa fa-map-marker"></span> Banaue, Ifugao, Philippines</p>
                                <ul>
                                    <li><span className="flaticon-shower"></span>2</li>
                                    <li><span className="flaticon-king-size"></span>3</li>
                                    <li><span className="flaticon-sun-umbrella"></span>Near Beach</li>
                                </ul> */}
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    </>

    );
};

export default Dashboard;
